import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Control, UseFormRegister, useFieldArray } from "react-hook-form";
import Divider from "@mui/material/Divider";
import { OmittedEmployee } from "entitites/employees/model/employee";
export const EduBody = ({
  register,
  control,
}: {
  register: UseFormRegister<OmittedEmployee>;
  control: Control<OmittedEmployee>;
}) => {
  const { fields, append, remove } = useFieldArray({
    name: "eduInfo.eduStages",
    control,
  });
  return (
    <Box width="100%" display="flex" gap={1.25} flexDirection="column">
      <Typography fontWeight={700} color="green.primary" variant="h6">
        Информация об обучении
      </Typography>
      {fields.map((field, index) => (
        <Box
          display="flex"
          flexDirection="column"
          key={field.id}
          fontWeight={600}
          width="100%"
        >
          <Box display="flex" alignItems="center" gap={1} mb={1.25}>
            <TextField
              inputProps={register(`eduInfo.eduStages.${index}.coachFio`)}
              label="Наставник"
              size="small"
              fullWidth
            />
            <TextField
              inputProps={register(`eduInfo.eduStages.${index}.position`)}
              label="Позиция обучения"
              size="small"
              fullWidth
            />
            <Button
              disableTouchRipple
              disableElevation
              sx={{
                textTransform: "none",
                fontWeight: 700,
                minWidth: 32,
              }}
              variant="contained"
              onClick={() => remove(index)}
            >
              x
            </Button>
          </Box>
          <NestedEduBody
            nestIndex={index}
            register={register}
            control={control}
          />
          <Divider />
        </Box>
      ))}
      <Button
        onClick={() =>
          append({
            dates: [{ name: "", date: "" }],
            coachFio: "",
            position: "",
          })
        }
        disableElevation
        sx={{
          textTransform: "none",
          minWidth: 277,
          fontWeight: 700,
        }}
        variant="contained"
      >
        Добавить информацию об обучении +
      </Button>
    </Box>
  );
};

const NestedEduBody = ({
  nestIndex,
  control,
  register,
}: {
  nestIndex: number;
  register: any;
  control: any;
}) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `eduInfo.eduStages.${nestIndex}.dates`,
  });
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      {fields.map((date, i) => (
        <Box
          key={date.id}
          display="flex"
          fontWeight={600}
          gap={1}
          mb={1.25}
          width="100%"
        >
          <TextField
            sx={{ width: 225 }}
            inputProps={register(
              `eduInfo.eduStages.${nestIndex}.dates.${i}.name`
            )}
            label="Этап"
            size="small"
          />
          <TextField
            sx={{ width: 225 }}
            inputProps={register(
              `eduInfo.eduStages.${nestIndex}.dates.${i}.date`
            )}
            label="Дата"
            size="small"
          />
          <Button
            disableTouchRipple
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
              minWidth: 32,
            }}
            variant="contained"
            onClick={() => append({ name: "", date: "" })}
          >
            +
          </Button>
          <Button
            disableTouchRipple
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
              minWidth: 32,
            }}
            variant="contained"
            onClick={() => remove(i)}
          >
            -
          </Button>
        </Box>
      ))}
      {fields.length === 0 && (
        <Button
          fullWidth
          disableTouchRipple
          disableElevation
          sx={{
            textTransform: "none",
            fontWeight: 700,
            mb: 1.25,
            height: 40,
          }}
          variant="contained"
          onClick={() => append({ name: "", date: "" })}
        >
          + Дату
        </Button>
      )}
    </Box>
  );
};
